// extracted by mini-css-extract-plugin
export default {"pageHeader":"pattern_pageHeader__hgG9d","pageHeaderTitle":"pattern_pageHeaderTitle__5tlyf","showHeaderSection":"pattern_showHeaderSection__uJuRQ"};